import { SET_MEDIA_HEALTH } from './actionTypes';
/**
 * 로컬 미디어 건강 상태를 갱신한다. senderHealth(modules/server/jitsi)만 dispatch 한다.
 */
export function setMediaHealth(state, reason) {
    return {
        type: SET_MEDIA_HEALTH,
        state,
        reason,
        since: Date.now(),
    };
}
